const SELECTORS = {
    NAV: '.js-main-nav',
    TOGGLE: '.js-main-nav-toggle',
    LEVEL_TOGGLE: '.js-main-nav-toggle-level',
    LEVEL_TOGGLE_MOBILE: '.js-main-nav-toggle-level-mobile',
    LEVEL_TOGGLE_MOBILE_TEXT: '.js-main-nav-toggle-level-mobile-parent',
    SUB_LIST_HOLDER_1: '.js-main-nav-sub-list-wrapper',
};

const MODIFIERS = {
    MAIN_NAV_OPEN: 'main-nav--open',
    LEVEL_1_OPEN: 'main-nav__sub-list-wrapper--open',
    LEVEL_2_OPEN: 'main-nav__sub-list__sub-list__wrapper--open',
    LEVEL_TOGGLE_MOBILE_VISIBLE: 'main-nav__mobile-controls__control--visible',
    CURRENT_PARENT_VISIBLE: 'main-nav__mobile-header__current-parent--visible',
    TOGGLE_LEVEL_VISBLE: 'main-nav__mobile-controls__control--visible',
    TOGGLE_ACTIVE: 'active',
};

export {
    SELECTORS,
    MODIFIERS,
};
